import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4 lg:gap-6 px-4" }
const _hoisted_2 = { class: "col-span-1" }
const _hoisted_3 = { class: "col-span-1" }
const _hoisted_4 = { class: "col-span-1" }

import {  // store
		localesStore as _localesStore
	} from '@/store/locales'
	
	
	const __default__ = { name: 'PersonalInformation' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		contact: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props
	
	const localesStore = _localesStore()

return (_ctx: any,_cache: any) => {
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('24'),
        value: __props.contact?.fieldData?.dob || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('27'),
        value: __props.contact?.fieldData?.['contact__contact_info__NATIONALITIES__nationalityID::name_display'] || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('30'),
        value: __props.contact?.fieldData?.['contact__contact_info__UNIVERSITIES__universityID::name_display'] || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ])
  ]))
}
}

})